// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";
import { SiteNetwork, SiteNetworkT, verifySiteNetwork } from "../net-config/site-network";

/**
 * Full server record matching the `servers` `PostgreSQL` table.
 */
export class Server implements flatbuffers.IUnpackableObject<ServerT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Server {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsServer(bb: flatbuffers.ByteBuffer, obj?: Server): Server {
    return (obj || new Server()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsServer(bb: flatbuffers.ByteBuffer, obj?: Server): Server {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Server()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  orgId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  ip(): string;
  ip(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  ip(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  fbEnabled(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  macAddress(): string | null;
  macAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  macAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  serialNumber(): string | null;
  serialNumber(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  serialNumber(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  edgeHostname(): string | null;
  edgeHostname(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  edgeHostname(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  dbPass(): string | null;
  dbPass(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  dbPass(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cpuModel(): string | null;
  cpuModel(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cpuModel(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  osVersion(): string | null;
  osVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  osVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  tunnelPort(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  pgPort(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  memoryGb(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  diskGb(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  syncSched(): string | null;
  syncSched(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  syncSched(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  syncQuestDbSched(): string | null;
  syncQuestDbSched(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  syncQuestDbSched(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  dbName(): string | null;
  dbName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  dbName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cloudDb(): string | null;
  cloudDb(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cloudDb(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  dbUser(): string | null;
  dbUser(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  dbUser(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  vtsTarget(): string | null;
  vtsTarget(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vtsTarget(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  provisionStatus(): string | null;
  provisionStatus(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  provisionStatus(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  provisionedAt(): string | null;
  provisionedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  provisionedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  registeredAt(): string | null;
  registeredAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  registeredAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  lastSuccessfulQuestDbSyncRun(): string | null;
  lastSuccessfulQuestDbSyncRun(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lastSuccessfulQuestDbSyncRun(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  nextQuestDbSyncRun(): string | null;
  nextQuestDbSyncRun(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  nextQuestDbSyncRun(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  nextRecordsSyncRun(): string | null;
  nextRecordsSyncRun(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  nextRecordsSyncRun(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  nextServerSyncRun(): string | null;
  nextServerSyncRun(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  nextServerSyncRun(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  recordSyncSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 100;
  }

  localPgPort(): number {
    const offset = this.bb!.__offset(this.bb_pos, 64);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 6432;
  }

  syncedAt(): string | null;
  syncedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  syncedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 66);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 68);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 70);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 72);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Number of channels currently associated with this server. Populated by
   * list endpoints so the UI can render a count without a separate fetch.
   */
  channelCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 74);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Number of adapters currently associated with this server.
   */
  adapterCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 76);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Site network, edited in the setup wizard and handed to the edge server
   * at first boot via GET /edge/config/:mac. Empty means "keep whatever the
   * gold image baked in", which is what every server predating this has.
   *
   * Appended at the table's end deliberately: `FlatBuffers` tolerates new
   * trailing fields, so every already-serialised Server still decodes.
   */
  siteNetwork(obj?: SiteNetwork): SiteNetwork | null {
    const offset = this.bb!.__offset(this.bb_pos, 78);
    return offset
      ? (obj || new SiteNetwork()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startServer(builder: flatbuffers.Builder) {
    builder.startObject(38);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrgId(builder: flatbuffers.Builder, orgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, orgIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nameOffset, 0);
  }

  static addIp(builder: flatbuffers.Builder, ipOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, ipOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(4, +active, +true);
  }

  static addFbEnabled(builder: flatbuffers.Builder, fbEnabled: boolean) {
    builder.addFieldInt8(5, +fbEnabled, +false);
  }

  static addMacAddress(builder: flatbuffers.Builder, macAddressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, macAddressOffset, 0);
  }

  static addSerialNumber(builder: flatbuffers.Builder, serialNumberOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, serialNumberOffset, 0);
  }

  static addEdgeHostname(builder: flatbuffers.Builder, edgeHostnameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, edgeHostnameOffset, 0);
  }

  static addDbPass(builder: flatbuffers.Builder, dbPassOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, dbPassOffset, 0);
  }

  static addCpuModel(builder: flatbuffers.Builder, cpuModelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, cpuModelOffset, 0);
  }

  static addOsVersion(builder: flatbuffers.Builder, osVersionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, osVersionOffset, 0);
  }

  static addTunnelPort(builder: flatbuffers.Builder, tunnelPort: number) {
    builder.addFieldInt32(12, tunnelPort, 0);
  }

  static addPgPort(builder: flatbuffers.Builder, pgPort: number) {
    builder.addFieldInt32(13, pgPort, 0);
  }

  static addMemoryGb(builder: flatbuffers.Builder, memoryGb: number) {
    builder.addFieldInt32(14, memoryGb, 0);
  }

  static addDiskGb(builder: flatbuffers.Builder, diskGb: number) {
    builder.addFieldInt32(15, diskGb, 0);
  }

  static addSyncSched(builder: flatbuffers.Builder, syncSchedOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, syncSchedOffset, 0);
  }

  static addSyncQuestDbSched(
    builder: flatbuffers.Builder,
    syncQuestDbSchedOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(17, syncQuestDbSchedOffset, 0);
  }

  static addDbName(builder: flatbuffers.Builder, dbNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, dbNameOffset, 0);
  }

  static addCloudDb(builder: flatbuffers.Builder, cloudDbOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, cloudDbOffset, 0);
  }

  static addDbUser(builder: flatbuffers.Builder, dbUserOffset: flatbuffers.Offset) {
    builder.addFieldOffset(20, dbUserOffset, 0);
  }

  static addVtsTarget(builder: flatbuffers.Builder, vtsTargetOffset: flatbuffers.Offset) {
    builder.addFieldOffset(21, vtsTargetOffset, 0);
  }

  static addProvisionStatus(
    builder: flatbuffers.Builder,
    provisionStatusOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(22, provisionStatusOffset, 0);
  }

  static addProvisionedAt(builder: flatbuffers.Builder, provisionedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(23, provisionedAtOffset, 0);
  }

  static addRegisteredAt(builder: flatbuffers.Builder, registeredAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(24, registeredAtOffset, 0);
  }

  static addLastSuccessfulQuestDbSyncRun(
    builder: flatbuffers.Builder,
    lastSuccessfulQuestDbSyncRunOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(25, lastSuccessfulQuestDbSyncRunOffset, 0);
  }

  static addNextQuestDbSyncRun(
    builder: flatbuffers.Builder,
    nextQuestDbSyncRunOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(26, nextQuestDbSyncRunOffset, 0);
  }

  static addNextRecordsSyncRun(
    builder: flatbuffers.Builder,
    nextRecordsSyncRunOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(27, nextRecordsSyncRunOffset, 0);
  }

  static addNextServerSyncRun(
    builder: flatbuffers.Builder,
    nextServerSyncRunOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(28, nextServerSyncRunOffset, 0);
  }

  static addRecordSyncSize(builder: flatbuffers.Builder, recordSyncSize: number) {
    builder.addFieldInt32(29, recordSyncSize, 100);
  }

  static addLocalPgPort(builder: flatbuffers.Builder, localPgPort: number) {
    builder.addFieldInt32(30, localPgPort, 6432);
  }

  static addSyncedAt(builder: flatbuffers.Builder, syncedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(31, syncedAtOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(32, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(33, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(34, deletedAtOffset, 0);
  }

  static addChannelCount(builder: flatbuffers.Builder, channelCount: number) {
    builder.addFieldInt32(35, channelCount, 0);
  }

  static addAdapterCount(builder: flatbuffers.Builder, adapterCount: number) {
    builder.addFieldInt32(36, adapterCount, 0);
  }

  static addSiteNetwork(builder: flatbuffers.Builder, siteNetworkOffset: flatbuffers.Offset) {
    builder.addFieldOffset(37, siteNetworkOffset, 0);
  }

  static endServer(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // org_id
    builder.requiredField(offset, 8); // name
    builder.requiredField(offset, 10); // ip
    return offset;
  }

  unpack(): ServerT {
    return new ServerT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.orgId() !== null ? this.orgId()!.unpack() : null,
      this.name(),
      this.ip(),
      this.active(),
      this.fbEnabled(),
      this.macAddress(),
      this.serialNumber(),
      this.edgeHostname(),
      this.dbPass(),
      this.cpuModel(),
      this.osVersion(),
      this.tunnelPort(),
      this.pgPort(),
      this.memoryGb(),
      this.diskGb(),
      this.syncSched(),
      this.syncQuestDbSched(),
      this.dbName(),
      this.cloudDb(),
      this.dbUser(),
      this.vtsTarget(),
      this.provisionStatus(),
      this.provisionedAt(),
      this.registeredAt(),
      this.lastSuccessfulQuestDbSyncRun(),
      this.nextQuestDbSyncRun(),
      this.nextRecordsSyncRun(),
      this.nextServerSyncRun(),
      this.recordSyncSize(),
      this.localPgPort(),
      this.syncedAt(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.channelCount(),
      this.adapterCount(),
      this.siteNetwork() !== null ? this.siteNetwork()!.unpack() : null,
    );
  }

  unpackTo(_o: ServerT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    _o.name = this.name();
    _o.ip = this.ip();
    _o.active = this.active();
    _o.fbEnabled = this.fbEnabled();
    _o.macAddress = this.macAddress();
    _o.serialNumber = this.serialNumber();
    _o.edgeHostname = this.edgeHostname();
    _o.dbPass = this.dbPass();
    _o.cpuModel = this.cpuModel();
    _o.osVersion = this.osVersion();
    _o.tunnelPort = this.tunnelPort();
    _o.pgPort = this.pgPort();
    _o.memoryGb = this.memoryGb();
    _o.diskGb = this.diskGb();
    _o.syncSched = this.syncSched();
    _o.syncQuestDbSched = this.syncQuestDbSched();
    _o.dbName = this.dbName();
    _o.cloudDb = this.cloudDb();
    _o.dbUser = this.dbUser();
    _o.vtsTarget = this.vtsTarget();
    _o.provisionStatus = this.provisionStatus();
    _o.provisionedAt = this.provisionedAt();
    _o.registeredAt = this.registeredAt();
    _o.lastSuccessfulQuestDbSyncRun = this.lastSuccessfulQuestDbSyncRun();
    _o.nextQuestDbSyncRun = this.nextQuestDbSyncRun();
    _o.nextRecordsSyncRun = this.nextRecordsSyncRun();
    _o.nextServerSyncRun = this.nextServerSyncRun();
    _o.recordSyncSize = this.recordSyncSize();
    _o.localPgPort = this.localPgPort();
    _o.syncedAt = this.syncedAt();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.channelCount = this.channelCount();
    _o.adapterCount = this.adapterCount();
    _o.siteNetwork = this.siteNetwork() !== null ? this.siteNetwork()!.unpack() : null;
  }

  unpackFields(...fields: string[]): ServerT {
    const t = new ServerT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("org_id")) {
      t.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("ip")) {
      t.ip = this.ip();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("fb_enabled")) {
      t.fbEnabled = this.fbEnabled();
    }
    if (fieldSet.has("mac_address")) {
      t.macAddress = this.macAddress();
    }
    if (fieldSet.has("serial_number")) {
      t.serialNumber = this.serialNumber();
    }
    if (fieldSet.has("edge_hostname")) {
      t.edgeHostname = this.edgeHostname();
    }
    if (fieldSet.has("db_pass")) {
      t.dbPass = this.dbPass();
    }
    if (fieldSet.has("cpu_model")) {
      t.cpuModel = this.cpuModel();
    }
    if (fieldSet.has("os_version")) {
      t.osVersion = this.osVersion();
    }
    if (fieldSet.has("tunnel_port")) {
      t.tunnelPort = this.tunnelPort();
    }
    if (fieldSet.has("pg_port")) {
      t.pgPort = this.pgPort();
    }
    if (fieldSet.has("memory_gb")) {
      t.memoryGb = this.memoryGb();
    }
    if (fieldSet.has("disk_gb")) {
      t.diskGb = this.diskGb();
    }
    if (fieldSet.has("sync_sched")) {
      t.syncSched = this.syncSched();
    }
    if (fieldSet.has("sync_quest_db_sched")) {
      t.syncQuestDbSched = this.syncQuestDbSched();
    }
    if (fieldSet.has("db_name")) {
      t.dbName = this.dbName();
    }
    if (fieldSet.has("cloud_db")) {
      t.cloudDb = this.cloudDb();
    }
    if (fieldSet.has("db_user")) {
      t.dbUser = this.dbUser();
    }
    if (fieldSet.has("vts_target")) {
      t.vtsTarget = this.vtsTarget();
    }
    if (fieldSet.has("provision_status")) {
      t.provisionStatus = this.provisionStatus();
    }
    if (fieldSet.has("provisioned_at")) {
      t.provisionedAt = this.provisionedAt();
    }
    if (fieldSet.has("registered_at")) {
      t.registeredAt = this.registeredAt();
    }
    if (fieldSet.has("last_successful_quest_db_sync_run")) {
      t.lastSuccessfulQuestDbSyncRun = this.lastSuccessfulQuestDbSyncRun();
    }
    if (fieldSet.has("next_quest_db_sync_run")) {
      t.nextQuestDbSyncRun = this.nextQuestDbSyncRun();
    }
    if (fieldSet.has("next_records_sync_run")) {
      t.nextRecordsSyncRun = this.nextRecordsSyncRun();
    }
    if (fieldSet.has("next_server_sync_run")) {
      t.nextServerSyncRun = this.nextServerSyncRun();
    }
    if (fieldSet.has("record_sync_size")) {
      t.recordSyncSize = this.recordSyncSize();
    }
    if (fieldSet.has("local_pg_port")) {
      t.localPgPort = this.localPgPort();
    }
    if (fieldSet.has("synced_at")) {
      t.syncedAt = this.syncedAt();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("channel_count")) {
      t.channelCount = this.channelCount();
    }
    if (fieldSet.has("adapter_count")) {
      t.adapterCount = this.adapterCount();
    }
    if (fieldSet.has("site_network")) {
      t.siteNetwork = this.siteNetwork() !== null ? this.siteNetwork()!.unpack() : null;
    }
    return t;
  }
}

export class ServerT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public orgId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public ip: string | Uint8Array | null = null,
    public active: boolean = true,
    public fbEnabled: boolean = false,
    public macAddress: string | Uint8Array | null = null,
    public serialNumber: string | Uint8Array | null = null,
    public edgeHostname: string | Uint8Array | null = null,
    public dbPass: string | Uint8Array | null = null,
    public cpuModel: string | Uint8Array | null = null,
    public osVersion: string | Uint8Array | null = null,
    public tunnelPort: number = 0,
    public pgPort: number = 0,
    public memoryGb: number = 0,
    public diskGb: number = 0,
    public syncSched: string | Uint8Array | null = null,
    public syncQuestDbSched: string | Uint8Array | null = null,
    public dbName: string | Uint8Array | null = null,
    public cloudDb: string | Uint8Array | null = null,
    public dbUser: string | Uint8Array | null = null,
    public vtsTarget: string | Uint8Array | null = null,
    public provisionStatus: string | Uint8Array | null = null,
    public provisionedAt: string | Uint8Array | null = null,
    public registeredAt: string | Uint8Array | null = null,
    public lastSuccessfulQuestDbSyncRun: string | Uint8Array | null = null,
    public nextQuestDbSyncRun: string | Uint8Array | null = null,
    public nextRecordsSyncRun: string | Uint8Array | null = null,
    public nextServerSyncRun: string | Uint8Array | null = null,
    public recordSyncSize: number = 100,
    public localPgPort: number = 6432,
    public syncedAt: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public channelCount: number = 0,
    public adapterCount: number = 0,
    public siteNetwork: SiteNetworkT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.orgId === null || this.orgId === undefined) {
      throw new Error('Required field "org_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    if (this.ip === null || this.ip === undefined) {
      throw new Error('Required field "ip" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const orgId = this.orgId !== null ? this.orgId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const ip = this.ip !== null ? builder.createString(this.ip!) : 0;
    const macAddress = this.macAddress !== null ? builder.createString(this.macAddress!) : 0;
    const serialNumber = this.serialNumber !== null ? builder.createString(this.serialNumber!) : 0;
    const edgeHostname = this.edgeHostname !== null ? builder.createString(this.edgeHostname!) : 0;
    const dbPass = this.dbPass !== null ? builder.createString(this.dbPass!) : 0;
    const cpuModel = this.cpuModel !== null ? builder.createString(this.cpuModel!) : 0;
    const osVersion = this.osVersion !== null ? builder.createString(this.osVersion!) : 0;
    const syncSched = this.syncSched !== null ? builder.createString(this.syncSched!) : 0;
    const syncQuestDbSched =
      this.syncQuestDbSched !== null ? builder.createString(this.syncQuestDbSched!) : 0;
    const dbName = this.dbName !== null ? builder.createString(this.dbName!) : 0;
    const cloudDb = this.cloudDb !== null ? builder.createString(this.cloudDb!) : 0;
    const dbUser = this.dbUser !== null ? builder.createString(this.dbUser!) : 0;
    const vtsTarget = this.vtsTarget !== null ? builder.createString(this.vtsTarget!) : 0;
    const provisionStatus =
      this.provisionStatus !== null ? builder.createString(this.provisionStatus!) : 0;
    const provisionedAt =
      this.provisionedAt !== null ? builder.createString(this.provisionedAt!) : 0;
    const registeredAt = this.registeredAt !== null ? builder.createString(this.registeredAt!) : 0;
    const lastSuccessfulQuestDbSyncRun =
      this.lastSuccessfulQuestDbSyncRun !== null
        ? builder.createString(this.lastSuccessfulQuestDbSyncRun!)
        : 0;
    const nextQuestDbSyncRun =
      this.nextQuestDbSyncRun !== null ? builder.createString(this.nextQuestDbSyncRun!) : 0;
    const nextRecordsSyncRun =
      this.nextRecordsSyncRun !== null ? builder.createString(this.nextRecordsSyncRun!) : 0;
    const nextServerSyncRun =
      this.nextServerSyncRun !== null ? builder.createString(this.nextServerSyncRun!) : 0;
    const syncedAt = this.syncedAt !== null ? builder.createString(this.syncedAt!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const siteNetwork = this.siteNetwork !== null ? this.siteNetwork!.pack(builder) : 0;

    Server.startServer(builder);
    Server.addId(builder, id);
    Server.addOrgId(builder, orgId);
    Server.addName(builder, name);
    Server.addIp(builder, ip);
    Server.addActive(builder, this.active);
    Server.addFbEnabled(builder, this.fbEnabled);
    Server.addMacAddress(builder, macAddress);
    Server.addSerialNumber(builder, serialNumber);
    Server.addEdgeHostname(builder, edgeHostname);
    Server.addDbPass(builder, dbPass);
    Server.addCpuModel(builder, cpuModel);
    Server.addOsVersion(builder, osVersion);
    Server.addTunnelPort(builder, this.tunnelPort);
    Server.addPgPort(builder, this.pgPort);
    Server.addMemoryGb(builder, this.memoryGb);
    Server.addDiskGb(builder, this.diskGb);
    Server.addSyncSched(builder, syncSched);
    Server.addSyncQuestDbSched(builder, syncQuestDbSched);
    Server.addDbName(builder, dbName);
    Server.addCloudDb(builder, cloudDb);
    Server.addDbUser(builder, dbUser);
    Server.addVtsTarget(builder, vtsTarget);
    Server.addProvisionStatus(builder, provisionStatus);
    Server.addProvisionedAt(builder, provisionedAt);
    Server.addRegisteredAt(builder, registeredAt);
    Server.addLastSuccessfulQuestDbSyncRun(builder, lastSuccessfulQuestDbSyncRun);
    Server.addNextQuestDbSyncRun(builder, nextQuestDbSyncRun);
    Server.addNextRecordsSyncRun(builder, nextRecordsSyncRun);
    Server.addNextServerSyncRun(builder, nextServerSyncRun);
    Server.addRecordSyncSize(builder, this.recordSyncSize);
    Server.addLocalPgPort(builder, this.localPgPort);
    Server.addSyncedAt(builder, syncedAt);
    Server.addCreatedAt(builder, createdAt);
    Server.addUpdatedAt(builder, updatedAt);
    Server.addDeletedAt(builder, deletedAt);
    Server.addChannelCount(builder, this.channelCount);
    Server.addAdapterCount(builder, this.adapterCount);
    Server.addSiteNetwork(builder, siteNetwork);

    return Server.endServer(builder);
  }

  clone(): ServerT {
    const obj = new ServerT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.orgId = this.orgId !== null ? this.orgId!.clone() : null;
    obj.name = this.name;
    obj.ip = this.ip;
    obj.active = this.active;
    obj.fbEnabled = this.fbEnabled;
    obj.macAddress = this.macAddress;
    obj.serialNumber = this.serialNumber;
    obj.edgeHostname = this.edgeHostname;
    obj.dbPass = this.dbPass;
    obj.cpuModel = this.cpuModel;
    obj.osVersion = this.osVersion;
    obj.tunnelPort = this.tunnelPort;
    obj.pgPort = this.pgPort;
    obj.memoryGb = this.memoryGb;
    obj.diskGb = this.diskGb;
    obj.syncSched = this.syncSched;
    obj.syncQuestDbSched = this.syncQuestDbSched;
    obj.dbName = this.dbName;
    obj.cloudDb = this.cloudDb;
    obj.dbUser = this.dbUser;
    obj.vtsTarget = this.vtsTarget;
    obj.provisionStatus = this.provisionStatus;
    obj.provisionedAt = this.provisionedAt;
    obj.registeredAt = this.registeredAt;
    obj.lastSuccessfulQuestDbSyncRun = this.lastSuccessfulQuestDbSyncRun;
    obj.nextQuestDbSyncRun = this.nextQuestDbSyncRun;
    obj.nextRecordsSyncRun = this.nextRecordsSyncRun;
    obj.nextServerSyncRun = this.nextServerSyncRun;
    obj.recordSyncSize = this.recordSyncSize;
    obj.localPgPort = this.localPgPort;
    obj.syncedAt = this.syncedAt;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.channelCount = this.channelCount;
    obj.adapterCount = this.adapterCount;
    obj.siteNetwork = this.siteNetwork !== null ? this.siteNetwork!.clone() : null;
    return obj;
  }

  equals(other: ServerT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.orgId !== null && other.orgId !== null) {
      if (!this.orgId!.equals(other.orgId!)) return false;
    } else if (this.orgId !== other.orgId) return false;
    if (this.name !== other.name) return false;
    if (this.ip !== other.ip) return false;
    if (this.active !== other.active) return false;
    if (this.fbEnabled !== other.fbEnabled) return false;
    if (this.macAddress !== other.macAddress) return false;
    if (this.serialNumber !== other.serialNumber) return false;
    if (this.edgeHostname !== other.edgeHostname) return false;
    if (this.dbPass !== other.dbPass) return false;
    if (this.cpuModel !== other.cpuModel) return false;
    if (this.osVersion !== other.osVersion) return false;
    if (this.tunnelPort !== other.tunnelPort) return false;
    if (this.pgPort !== other.pgPort) return false;
    if (this.memoryGb !== other.memoryGb) return false;
    if (this.diskGb !== other.diskGb) return false;
    if (this.syncSched !== other.syncSched) return false;
    if (this.syncQuestDbSched !== other.syncQuestDbSched) return false;
    if (this.dbName !== other.dbName) return false;
    if (this.cloudDb !== other.cloudDb) return false;
    if (this.dbUser !== other.dbUser) return false;
    if (this.vtsTarget !== other.vtsTarget) return false;
    if (this.provisionStatus !== other.provisionStatus) return false;
    if (this.provisionedAt !== other.provisionedAt) return false;
    if (this.registeredAt !== other.registeredAt) return false;
    if (this.lastSuccessfulQuestDbSyncRun !== other.lastSuccessfulQuestDbSyncRun) return false;
    if (this.nextQuestDbSyncRun !== other.nextQuestDbSyncRun) return false;
    if (this.nextRecordsSyncRun !== other.nextRecordsSyncRun) return false;
    if (this.nextServerSyncRun !== other.nextServerSyncRun) return false;
    if (this.recordSyncSize !== other.recordSyncSize) return false;
    if (this.localPgPort !== other.localPgPort) return false;
    if (this.syncedAt !== other.syncedAt) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.channelCount !== other.channelCount) return false;
    if (this.adapterCount !== other.adapterCount) return false;
    if (this.siteNetwork !== null && other.siteNetwork !== null) {
      if (!this.siteNetwork!.equals(other.siteNetwork!)) return false;
    } else if (this.siteNetwork !== other.siteNetwork) return false;
    return true;
  }
}

export function verifyServer(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "org_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "ip");
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 4);
    verifier.checkScalarField(tablePos, 32, 4);
    verifier.checkScalarField(tablePos, 34, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 46);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 50);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 52);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 54);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 56);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 58);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 60);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 62, 4);
    verifier.checkScalarField(tablePos, 64, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 66);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 68);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 70);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 72);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 74, 4);
    verifier.checkScalarField(tablePos, 76, 4);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 78);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifySiteNetwork(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
